<template>
  <template class="flex text-menu-link font-medium">
    <RouterLink v-if="item.to" class="group relative w-full" :to="computedTo">
      <span class="flex gap-1">
        <span
          v-if="$t(`${label}`) === $t('Competitions') && item?.number_events && item?.number_events !== 0"
          class="whitespace-nowrap w-full overflow-hidden text-ellipsis text-base"
          >{{ $t(item.label) }}</span
        >
        <span
          v-else-if="$t(`${label}`) !== $t('Competitions')"
          class="whitespace-nowrap w-full overflow-hidden text-ellipsis text-base"
          >{{ $t(item.label) }}</span
        >
      </span>
      <span
        class="absolute -bottom-1 left-0 h-[4px] bg-primary max-w-[50%] transition-[width] duration-150 ease-out"
        :class="highlight() ? 'w-1/2' : 'w-0 group-hover:w-1/2'" />
    </RouterLink>
    <a v-else-if="item.href" class="group relative w-full" :href="item.href">
      <span class="flex gap-1">
        <span class="whitespace-nowrap w-full overflow-hidden text-ellipsis text-base">{{ item.label }}</span>
      </span>
      <span
        class="absolute -bottom-1 left-0 h-[4px] bg-primary max-w-[50%] transition-[width] duration-150 ease-out"
        :class="highlightAnchor() ? 'w-1/2' : 'w-0 group-hover:w-1/2'" />
    </a>
  </template>
</template>
<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const { item, label } = defineProps({
  item: Object,
  label: { required: false },
});

const highlight = () => {
  if (
    (!route.fullPath.includes("events") && route.fullPath.includes(item.to)) ||
    (!route.query.sport_type && !route.query.tournament && route.matched.some(({ path }) => path === item.to)) ||
    (!!route.query.sport_type && route.query.sport_type === `${item.label.toLowerCase()}`) ||
    (item.to === "/motorsport/formula-1" && route.fullPath.includes("/events?sport_type=formula1")) ||
    (route.fullPath === "/events?tournament=motogp-2024" && `${item.label.toLowerCase()}` === "motogp") ||
    (route.query.origin === "allevents" && item.label === "All events")
  ) {
    return "underline";
  }
};

const computedTo = computed(() => {
  const [path, rawQuery] = item.to.split("?");
  const existingQuery = new URLSearchParams(rawQuery);
  existingQuery.set("origin", item.label.replace(/\s/g, "").toLowerCase());

  return {
    path,
    query: Object.fromEntries(existingQuery.entries()),
  };
});
const highlightAnchor = () => {
  if (route.matched.some(({ path }) => path === item.to)) {
    return "underline";
  }
};

const route = useRoute();
</script>
